import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    getPaymentHistory: [],
    loading: false,
    error: null,
}

const getPaymentHistorySlice = createSlice({
    name: "getPaymentHistory",
    initialState,
    reducers: {
        fetchGetPaymentHistorySuccess: (state, action) => {
            state.loading = false;
            state.getPaymentHistory = action.payload;
        },
        fetchGetPaymentHistoryFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchGetPaymentHistorySuccess, fetchGetPaymentHistoryFailure } = getPaymentHistorySlice.actions;

export default getPaymentHistorySlice.reducer;
